import { Card } from "@/components/ui/card"
import FilledPrescriptions from "./filled-prescriptions"
import Refills from "./refills"
import ReturningCustomerRate from "./returning-customer-rate"
import NewPatients from "./new-patients"
import AvgPrescriptionValue from "./avg-prescription-value"
import TopPrescribedMedications from "./top-prescribed-medications"
import PatientReportsByMedicationType from "./patient-reports-by-medication-type"

export default function Screen() {
  return (
    <div className="h-full overflow-hidden">
      <Card className="border-0 shadow-none bg-transparent">
        <div className="pt-2 pb-4 flex items-center justify-between">
          <h1 className="text-3xl font-semibold">Activity</h1>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <button className="px-3 py-1 border rounded-xl">Share as report</button>
            <button className="px-3 py-1 border rounded-xl">…</button>
          </div>
        </div>
      </Card>
      <div className="h-[calc(100%-90px)] overflow-y-auto pr-1">
        <div className="flex gap-4 items-start">
          <div className="flex-1 min-w-[320px] flex flex-col gap-4">
            <FilledPrescriptions />
            <NewPatients />
          </div>
          <div className="flex-1 min-w-[320px] flex flex-col gap-4">
            <Refills />
            <AvgPrescriptionValue />
            <TopPrescribedMedications />
          </div>
          <div className="flex-1 min-w-[320px] flex flex-col gap-4">
            <ReturningCustomerRate variant="area" />
            <ReturningCustomerRate variant="bar" />
            <PatientReportsByMedicationType variant="type1" />
            <PatientReportsByMedicationType variant="type2" />
          </div>
        </div>
      </div>
    </div>
  )
}